import React from 'react';
import BarcodeScannerModal from './BarcodeScannerModal';

/**
 * BarcodeScanner component
 * Encapsulates all barcode scanning UI and logic.
 * Props:
 *   show: boolean - whether the modal is visible
 *   onDetected: function(barcode) - called with barcode string on successful scan
 *   onClose: function() - called to close the modal
 *   scanLoading, scanError: feedback states (optional)
 *   scannedProductData: object - product data after successful scan
 *   showScannedProduct: boolean - whether to show product details
 *   onConfirmProduct: function() - called when user confirms the product
 *   onRetryScanning: function() - called when user wants to scan again
 */
const BarcodeScanner = ({ 
  show, 
  onDetected, 
  onClose, 
  scanLoading, 
  scanError,
  scannedProductData,
  showScannedProduct,
  onConfirmProduct,
  onRetryScanning
}) => {  return (
    <BarcodeScannerModal
      show={show}
      onDetected={onDetected}
      onClose={onClose}
      scanLoading={scanLoading}
      scanError={scanError}
      scannedProductData={scannedProductData}
      showScannedProduct={showScannedProduct}
      onConfirmProduct={onConfirmProduct}
      onRetryScanning={onRetryScanning}
    />
  );
};

export default BarcodeScanner;
